<template>
  <notification @click="handleClick" :is-read="isRead" :created-at="createdAt">
    <h2 class="truncate">Paniers</h2>
    <p>{{ notification.data.carts.length > 1 ? 'Des paniers vont bientôt expirer.' : 'Un panier va bientôt expirer.' }}</p>
  </notification>
</template>

<script>
import Notification from '../notifications/Notification.vue';
import notification from '../../mixins/notification';

export default {
  components: { Notification },

  mixins: [notification],

  methods: {
    handleClick() {
      this.markAsRead().then(() =>
        this.$modal.open('notification-carts-expiring-soon', this.notification),
      );
    },
  },
};
</script>
